const CapacityWarning = () => {
  const warehouses = [
    { id: 1, name: "Warehouse A", limit: 1000, used: 900 },
    { id: 2, name: "Warehouse B", limit: 800, used: 600 },
  ];

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">容量警示</h2>
      <div className="grid grid-cols-2 gap-4">
        {warehouses.map((wh) => (
          <div key={wh.id} className="p-4 bg-white shadow rounded">
            <h3 className="font-bold">{wh.name}</h3>
            <div className="relative pt-2">
              <div className="overflow-hidden h-4 mb-4 text-xs flex rounded bg-gray-200">
                <div
                  style={{ width: `${(wh.used / wh.limit) * 100}%` }}
                  className={`shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center ${
                    (wh.used / wh.limit) > 0.9 ? "bg-red-500" : "bg-green-500"
                  }`}
                ></div>
              </div>
              <p>{`使用量：${wh.used} / ${wh.limit}`}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CapacityWarning;
